import { Action } from 'redux';

import { UpdateDataFreshnessPolicy } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface UpdateDataFreshnessPolicyAction extends Action {
  workbooks: IContentInfo[];
}

export function updateDataFreshnessPolicy(workbooks: IContentInfo[]): UpdateDataFreshnessPolicyAction {
  return {
    type: UpdateDataFreshnessPolicy,
    workbooks
  };
}

const isUpdateDataFreshessPolicyAction = isActionFactory<UpdateDataFreshnessPolicyAction>(UpdateDataFreshnessPolicy);
